export default "__VITE_ASSET___V1qqb1X__"